import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import paths from "../routes/paths";
import Guard from "components/access-control/rbac/Guard";
import { savePostLoginRedirect } from "utils/postLoginRedirect";

const ProtectedRoute = ({ children, privilege, fallback = null }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const hasSessionToken = Boolean(sessionStorage.getItem("authToken"));
  const isSessionAuthenticated = isAuthenticated && hasSessionToken;

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isSessionAuthenticated) {
    savePostLoginRedirect(
      `${location.pathname || ""}${location.search || ""}${location.hash || ""}`,
    );
    // Redirect to login page with return url
    return (
      <Navigate to={paths.simpleLogin} state={{ from: location }} replace />
    );
  }

  // If privilege is provided, wrap with Guard
  if (privilege) {
    return (
      <Guard privilege={privilege} fallback={fallback}>
        {children}
      </Guard>
    );
  }

  return children;
};

export default ProtectedRoute;
